import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/images/svg/illustrations/team-created.svg?data'


const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Team type ")
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Create team ")
const _hoisted_5 = { class: "create-successful" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "An illustration of a group of people sitting by a desk"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "h3" }, "Team created!", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Team ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" successfully created! ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAlert = _resolveComponent("AppAlert")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_AppTextarea = _resolveComponent("AppTextarea")!
  const _component_FilterUsersSelect = _resolveComponent("FilterUsersSelect")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Modal, {
      id: "create-group",
      title: "Create a team",
      theme: "create-group",
      onCloseModal: _ctx.handleModalClose
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_AppButton, {
          theme: "secondary",
          onClick: _ctx.handleModalClose
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_AppButton, {
          onClick: _ctx.createTeam,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        (Object.keys(_ctx.specialErrors).length > 0)
          ? (_openBlock(), _createBlock(_component_AppAlert, {
              key: 0,
              theme: "danger",
              icon: "error"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialErrors, (field) => {
                  return (_openBlock(), _createElementBlock("ul", { key: field }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(field), (error) => {
                      return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_AppInput, {
          id: "modal-input",
          modelValue: _ctx.teamName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teamName) = $event)),
          type: "text",
          label: "Team name",
          placeholder: "Enter team name",
          error: _ctx.fieldEmptyErrors.teamName || !!_ctx.specialErrors.teamName,
          maxlength: "30",
          autofocus: ""
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_AppDropdown, { type: "simple" }, {
          label: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createVNode(_component_AppSelect, {
              "max-height": 220,
              modelValue: _ctx.teamType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teamType) = $event)),
              options: _ctx.AVAILABLE_TEAM_INDUSTRIES,
              "close-on-select": "",
              onKeydownCapture: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"]))
            }, {
              toggle: _withCtx(({ isFocusing, toggle }) => [
                _createElementVNode("div", {
                  onClick: toggle,
                  onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"])),
                  class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                }, [
                  _createVNode(_component_AppIcon, { name: "arrow" })
                ], 42, _hoisted_2)
              ]),
              label: _withCtx(({ selected }) => [
                _createTextVNode(_toDisplayString(selected ? selected : 'Select team type'), 1)
              ]),
              "dropdown-item": _withCtx(({ option }) => [
                _createElementVNode("p", null, _toDisplayString(option), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_AppTextarea, {
          id: "modal-area",
          modelValue: _ctx.teamDescription,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.teamDescription) = $event)),
          type: "text",
          label: "Team description",
          placeholder: "Enter team description",
          resize: false,
          error: _ctx.fieldEmptyErrors.teamDescription || !!_ctx.specialErrors.teamDescription,
          rows: "4"
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_FilterUsersSelect, {
          modelValue: _ctx.selectedMembers,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedMembers) = $event)),
          title: "Members",
          teamMembers: _ctx.teamMembers,
          openDirection: "top"
        }, null, 8, ["modelValue", "teamMembers"])
      ]),
      _: 1
    }, 8, ["onCloseModal"]),
    _createVNode(_component_Modal, { id: "create-group-successful" }, {
      actions: _withCtx(() => [
        _createVNode(_component_AppButton, { onClick: _ctx.handleModalClose }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("p", null, [
            _hoisted_8,
            _createElementVNode("b", null, _toDisplayString(_ctx.teamName), 1),
            _hoisted_9
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}